module.exports = __webpack_public_path__ + "static/media/20.7aa62eb4.jpg";